import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesOrNoText',
})
export class YesOrNoTextPipe implements PipeTransform {
  transform(value?: boolean): string {
    if (value == null || value == undefined) {
      return '--';
    }
    return value ? 'Yes' : 'No';
  }
}
